/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Avatar,
  IconButton,
  Chip,
  Typography,
  FormControlLabel,
  Switch,
  Grid,
  MenuItem,
  Tabs,
  Tab,
} from '@mui/material';
import { CloudUpload, Delete as DeleteIcon } from '@mui/icons-material';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`agent-tabpanel-${index}`}
      aria-labelledby={`agent-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const AgentFormComponent = ({ onClose, onSubmit, sourceData }) => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    receiveStatsMail: true,
    published: true,
    agencyId: '',
    cityId: '',
    sourceReference: '',
    mobileNumber: '',
    mobileNumber1: '',
    mobileNumber2: '',
    mobileNumber3: '',
    emailAddress: '',
    faxNumber: '',
    workNumber: '',
    workNumber1: '',
    workNumber2: '',
    workNumber3: '',
    qualification: '',
    fidelityFundCertificationYear: '',
    fidelityFundCertificationNumber: '',
    idNumber: '',
    incomeTaxNumber: '',
    about: '',
    isBroker: false,
    countryId: '',
    profilePicture: null,
    profile: {
      facebook: '',
      twitter: ''
    },
    status: 'Active',
    jobTitle: ''
  });
  
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [tabValue, setTabValue] = useState(0);

  // Prefill form when sourceData changes
  useEffect(() => {
    if (sourceData) {
      setFormData(prev => ({
        ...prev,
        firstname: sourceData.firstname || sourceData.name?.split(' ')[0] || '',
        lastname: sourceData.lastname || sourceData.name?.split(' ')[1] || '',
        emailAddress: sourceData.emailAddress || sourceData.email || '',
        mobileNumber: sourceData.mobileNumber || sourceData.phone || '',
        // Add more mappings as needed based on your source data structure
      }));
    }
  }, [sourceData]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else if (name.startsWith('profile.')) {
      const profileField = name.split('.')[1];
      setFormData(prev => ({
        ...prev,
        profile: {
          ...prev.profile,
          [profileField]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }
    
    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
    
    // Convert image to base64
    const base64Reader = new FileReader();
    base64Reader.onload = (e) => {
      const base64 = e.target.result.split(',')[1];
      setFormData(prev => ({
        ...prev,
        profilePicture: {
          bytes: base64,
          mimeContentType: file.type,
          caption: `Profile picture of ${formData.firstname} ${formData.lastname}`.trim() || 'Agent profile picture'
        }
      }));
    };
    base64Reader.readAsDataURL(file);
  };

  const removeImage = () => {
    setImagePreview(null);
    setFormData(prev => ({
      ...prev,
      profilePicture: null
    }));
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };


  

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <DialogTitle>
        {sourceData ? `Create Agent from ${sourceData.name || sourceData.firstname || 'Record'}` : 'Add New Agent'}
      </DialogTitle>
      
      <Tabs value={tabValue} onChange={handleTabChange} sx={{ px: 3 }}>
        <Tab label="Basic Info" />
        <Tab label="Contact Details" />
        <Tab label="Professional Info" />
        <Tab label="Profile & Image" />
      </Tabs>

      <DialogContent sx={{ maxHeight: '60vh', overflow: 'auto' }}>
        {sourceData && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Prefilled from existing record
          </Typography>
        )}
        
        {/* Basic Info Tab */}
        <TabPanel value={tabValue} index={0}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="firstname"
                label="First Name"
                type="text"
                fullWidth
                variant="outlined"
                value={formData.firstname}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="lastname"
                label="Last Name"
                type="text"
                fullWidth
                variant="outlined"
                value={formData.lastname}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="jobTitle"
                label="Job Title"
                type="text"
                fullWidth
                variant="outlined"
                value={formData.jobTitle}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="emailAddress"
                label="Email Address"
                type="email"
                fullWidth
                variant="outlined"
                value={formData.emailAddress}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="idNumber"
                label="ID Number"
                type="text"
                fullWidth
                variant="outlined"
                value={formData.idNumber}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="incomeTaxNumber"
                label="Income Tax Number"
                type="text"
                fullWidth
                variant="outlined"
                value={formData.incomeTaxNumber}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="about"
                label="About"
                type="text"
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                value={formData.about}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.receiveStatsMail}
                    onChange={handleChange}
                    name="receiveStatsMail"
                  />
                }
                label="Receive Stats Mail"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.published}
                    onChange={handleChange}
                    name="published"
                  />
                }
                label="Published"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.isBroker}
                    onChange={handleChange}
                    name="isBroker"
                  />
                }
                label="Is Broker"
              />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Contact Details Tab */}
        <TabPanel value={tabValue} index={1}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="mobileNumber"
                label="Mobile Number (Primary)"
                type="tel"
                fullWidth
                variant="outlined"
                value={formData.mobileNumber}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="mobileNumber1"
                label="Mobile Number 1"
                type="tel"
                fullWidth
                variant="outlined"
                value={formData.mobileNumber1}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="mobileNumber2"
                label="Mobile Number 2"
                type="tel"
                fullWidth
                variant="outlined"
                value={formData.mobileNumber2}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="mobileNumber3"
                label="Mobile Number 3"
                type="tel"
                fullWidth
                variant="outlined"
                value={formData.mobileNumber3}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="workNumber"
                label="Work Number (Primary)"
                type="tel"
                fullWidth
                variant="outlined"
                value={formData.workNumber}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="workNumber1"
                label="Work Number 1"
                type="tel"
                fullWidth
                variant="outlined"
                value={formData.workNumber1}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="workNumber2"
                label="Work Number 2"
                type="tel"
                fullWidth
                variant="outlined"
                value={formData.workNumber2}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="workNumber3"
                label="Work Number 3"
                type="tel"
                fullWidth
                variant="outlined"
                value={formData.workNumber3}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="faxNumber"
                label="Fax Number"
                type="tel"
                fullWidth
                variant="outlined"
                value={formData.faxNumber}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Professional Info Tab */}
        <TabPanel value={tabValue} index={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="agencyId"
                label="Agency ID"
                type="number"
                fullWidth
                variant="outlined"
                value={formData.agencyId}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="cityId"
                label="City ID"
                type="number"
                fullWidth
                variant="outlined"
                value={formData.cityId}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="countryId"
                label="Country ID"
                type="number"
                fullWidth
                variant="outlined"
                value={formData.countryId}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="sourceReference"
                label="Source Reference"
                type="text"
                fullWidth
                variant="outlined"
                value={formData.sourceReference}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="qualification"
                label="Qualification"
                type="text"
                fullWidth
                variant="outlined"
                value={formData.qualification}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="fidelityFundCertificationYear"
                label="Fidelity Fund Certification Year"
                type="text"
                fullWidth
                variant="outlined"
                value={formData.fidelityFundCertificationYear}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="fidelityFundCertificationNumber"
                label="Fidelity Fund Certification Number"
                type="text"
                fullWidth
                variant="outlined"
                value={formData.fidelityFundCertificationNumber}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="status"
                label="Status"
                select
                fullWidth
                variant="outlined"
                value={formData.status}
                onChange={handleChange}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Profile & Image Tab */}
        <TabPanel value={tabValue} index={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="profile.facebook"
                label="Facebook URL"
                type="url"
                fullWidth
                variant="outlined"
                value={formData.profile.facebook}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                name="profile.twitter"
                label="Twitter URL"
                type="url"
                fullWidth
                variant="outlined"
                value={formData.profile.twitter}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
                <Avatar
                  src={imagePreview}
                  sx={{ width: 100, height: 100, mb: 2 }}
                />
                
                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="agent-image-upload"
                  type="file"
                  onChange={handleImageUpload}
                  ref={fileInputRef}
                />
                
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <label htmlFor="agent-image-upload">
                    <Button
                      variant="outlined"
                      component="span"
                      startIcon={<CloudUpload />}
                    >
                      Upload Profile Picture
                    </Button>
                  </label>
                  
                  {imagePreview && (
                    <IconButton 
                      color="error" 
                      onClick={removeImage}
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
                
                {formData.profilePicture && (
                  <Chip 
                    label="Image ready" 
                    color="success" 
                    variant="outlined" 
                    size="small" 
                    sx={{ mt: 1 }} 
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {/* <Button type="submit" variant="contained" color="success">
          Add Agent
        </Button> */}
      </DialogActions>
    </Box>
  );
};

export default AgentFormComponent;